export default "__VITE_ASSET__z9UiE9Av__"